import React from 'react';
import { Carousel } from 'react-responsive-carousel';
export function BuyCarousel(_a) {
    var contents = _a.contents, showIndicators = _a.showIndicators;
    return (React.createElement(Carousel, { className: "buy-carousel", showThumbs: false, showArrows: false, showStatus: false, autoPlay: true, infiniteLoop: true, interval: 5000, showIndicators: showIndicators }, contents.map(function (content, index) { return (React.createElement("p", { className: "carousel-content", key: index }, content)); })));
}
//# sourceMappingURL=BuyCarousel.js.map